import { defineComponent as _defineComponent } from 'vue'
import { useBattle } from '@/enitites/battle'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventBattles',
  props: {
    eventData: null
  },
  setup(__props: any) {



const { getBattleCategoryName } = useBattle()

return { __sfc: true,getBattleCategoryName }
}

})